const validarpermiso = (collection, action, permisos) => {
  const permisosresult = permisos?.filter(
    (permission) =>
      permission.collection === collection && permission.action === action
  );

  if (permisosresult.length > 0) {
    return true;
  } else {
    return false;
  }
};
export default validarpermiso;

export const formatUser = (user) => {
  if (!user) return "N/A";
  return `${user.first_name || ""} ${user.last_name || ""} (${
    user.email || "Sin email"
  })`.trim();
};

export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleString();
};

export const getStatusColor = (estado) => {
  const colors = {
    creada: "blue",
    anulada: "red",
    pagada: "green",
    pendiente: "gold",
  };
  return colors[estado] || "default";
};

export const calculateTotals = (productos) => {
  return productos?.reduce(
    (acc, producto) => {
      const cantidad = producto.cantidad || 0;
      const precioUnitario = producto.precio_unitario || 0;
      const impuesto = producto.producto?.grupo?.impuesto || 0;

      const subtotal = cantidad * precioUnitario;
      const impuestoValor = (subtotal * impuesto) / 100;

      return {
        subtotal: acc.subtotal + subtotal,
        impuestoTotal: acc.impuestoTotal + impuestoValor,
        total: acc.total + (subtotal + impuestoValor),
      };
    },
    { subtotal: 0, impuestoTotal: 0, total: 0 }
  );
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
  }).format(amount);
};
